import React, { useState, useCallback } from "react";
import { debounce } from "lodash";
export const noop = () => { };
export function useDebounce(ms, fn, deps) {
    return useCallback(debounce(fn, ms), deps);
}
export function StateContainer({ children, initial }) {
    const [value, onChange] = useState(initial);
    console.log('state:', value);
    return children({ value, onChange });
}
export function withState(initial, fn) {
    return () => (React.createElement(StateContainer, { initial: initial }, fn));
}
//# sourceMappingURL=util.js.map